enum MachineType {
    Standart = 0,
    Studio = 1
}

const MachineTypeValue = {
    GetText: (typeNumber: number) => {
        return MachineType[typeNumber].valueOf()
    }
}

export default MachineTypeValue